export default "__VITE_ASSET__1c8566c7__"